document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.mat-grid-cstm');

  sections.forEach(function (section) {
    const filterBtns = section.querySelectorAll('.mat-grid-cstm__filter-btn');
    const cards = section.querySelectorAll('.mat-grid-cstm__card');
    const emptyState = section.querySelector('.mat-grid-cstm__empty');

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const filter = btn.dataset.filter;

        // Update active button
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        // Show/hide cards
        let visibleCount = 0;
        cards.forEach(function (card) {
          const categories = card.dataset.categories || '';
          const show = filter === 'all' || categories.split(',').map(s => s.trim()).includes(filter);
          card.dataset.hidden = show ? 'false' : 'true';
          if (show) visibleCount++;
        });

        // Empty state
        if (emptyState) {
          emptyState.classList.toggle('is-visible', visibleCount === 0);
        }
      });
    });
  });
});
